module.exports = __webpack_public_path__ + "img/JHUJIAN.8860f05e.svg";